import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import {
  Button,
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import { BackdropCircular, Breadcrumb } from 'components';
import { getAutoQuotesApi } from 'api/automatedQuotes';
import { setSelectedAutoQuote } from 'redux/actions/automated_quotes';
import { useStyles } from './styles';


const AutomatedQuotes = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { autoQuotes, autoQuotesLoading } = useSelector((state: IReduxState) => state.automatedQuotes);

  useEffect(() => {
    getAutoQuotesApi({ dispatch });
  }, []);

  const handleRunAutomation = (data) => {
    dispatch(setSelectedAutoQuote(data));
    history.push(`/automated-quotes/${data.id}/customer-preview`);
  };

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb routeSegments={[{ name: 'Automated Quotes' }]} />
      </div>
      <Card className="mx-5 pt-8 root-card">
        <div className="flex-grow h-full pb-8 px-8">
          <Grid container spacing={2} alignItems="center" className={`${classes.segmentsDotted} mt-4`}>
            <Grid item xs={12}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell width={100} align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {autoQuotesLoading && (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        Loading...
                      </TableCell>
                    </TableRow>
                  )}
                  {!autoQuotesLoading && autoQuotes?.length ? (
                    autoQuotes.map((automation) => (
                      <TableRow key={automation.id}>
                        <TableCell>{automation.name}</TableCell>
                        <TableCell>{automation.description}</TableCell>
                        <TableCell align="center">
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleRunAutomation(automation)}
                          >
                            Run
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    !autoQuotesLoading && (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          No matching quotes found.
                        </TableCell>
                      </TableRow>
                    )
                  )}
                </TableBody>

              </Table>
            </Grid>
          </Grid>
        </div>
      </Card>
      <BackdropCircular loading={autoQuotesLoading} />
    </div>
  );
};

export default AutomatedQuotes;
